'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dAbstract$002dCollection from "./java.util.-Abstract-Collection.js";
import * as $j_java$002eutil$002e$002dList from "./java.util.-List.js";
import * as $j_java$002eutil$002e$002dRandom$002dAccess$002dList$002dIterator from "./java.util.-Random-Access-List-Iterator.js";
var $p;
/** @constructor */
function $c_ju_AbstractList() {
}
export { $c_ju_AbstractList as $c_ju_AbstractList };
$p = $c_ju_AbstractList.prototype = new $j_java$002eutil$002e$002dAbstract$002dCollection.$h_ju_AbstractCollection();
$p.constructor = $c_ju_AbstractList;
/** @constructor */
function $h_ju_AbstractList() {
}
export { $h_ju_AbstractList as $h_ju_AbstractList };
$h_ju_AbstractList.prototype = $p;
$p.eP = (function(element) {
  this.NQ(this.T(), element);
  return true;
});
$p.Ct = (function(index, element) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_UnsupportedOperationException__(new $j_java$002elang$002e$002dObject.$c_jl_UnsupportedOperationException());
});
$p.NQ = (function(index, element) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_UnsupportedOperationException__(new $j_java$002elang$002e$002dObject.$c_jl_UnsupportedOperationException());
});
$p.us = (function(index) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_UnsupportedOperationException__(new $j_java$002elang$002e$002dObject.$c_jl_UnsupportedOperationException());
});
$p.cV = (function() {
  return this.xD(0);
});
$p.C1 = (function() {
  return this.xD(0);
});
$p.xD = (function(index) {
  var length = this.T();
  if (((index >>> 0) > (length >>> 0))) {
    $j_java$002elang$002e$002dObject.$m_jl_BoundsChecks$().xt(index, length);
  }
  return new $j_java$002eutil$002e$002dRandom$002dAccess$002dList$002dIterator.$c_ju_RandomAccessListIterator(this, index, 0, this.T());
});
$p.f = (function(o) {
  if ((o === this)) {
    return true;
  } else if ($j_java$002eutil$002e$002dList.$is_ju_List(o)) {
    var oIter = o.C1();
    var _\uff3fself = this.xD(0);
    _return: {
      while (_\uff3fself.i()) {
        var t = _\uff3fself.e();
        if (oIter.i()) {
          var b = oIter.e();
          var $x_2 = ((t === null) ? (b === null) : $j_java$002elang$002e$002dObject.$dp_equals__O__Z(t, b));
        } else {
          var $x_2 = false;
        }
        if ((!$x_2)) {
          var $x_1 = true;
          break _return;
        }
      }
      var $x_1 = false;
    }
    if ((!$x_1)) {
      return (!oIter.i());
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  var _\uff3fself = this.xD(0);
  var result = 1;
  while (_\uff3fself.i()) {
    var t = result;
    var u = _\uff3fself.e();
    result = ((Math.imul(31, (t | 0)) + ((u === null) ? 0 : $j_java$002elang$002e$002dObject.$dp_hashCode__I(u))) | 0);
  }
  return (result | 0);
});
